import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';

interface AgentSourcesBadgesProps {
    loading: boolean;
    mcpServerNames: string[] | null;
}

export const agentBadgeClassName =
    'inline-flex items-center gap-1.5 bg-muted/50 hover:bg-muted/50 px-2 py-1.5 border border-border/50 font-medium text-muted-foreground text-xs';

export function AgentSourcesBadges({
    loading,
    mcpServerNames
}: AgentSourcesBadgesProps) {
    return (
        <div className="flex flex-wrap gap-1.5">
            {loading && (
                <>
                    <Skeleton className="rounded-full w-20 h-7" />
                    <Skeleton className="rounded-full w-14 h-7" />
                </>
            )}
            {!loading && mcpServerNames?.length === 0 && (
                <span className="text-muted-foreground text-xs">
                    No sources
                </span>
            )}
            {!loading &&
                mcpServerNames?.map((name) => (
                    <Badge
                        key={name}
                        variant="secondary"
                        className={agentBadgeClassName}
                    >
                        {name}
                    </Badge>
                ))}
        </div>
    );
}
